/* global localStorage */
(function () {
  'use strict';

  angular
    .module('corePermissoes')
    .value('routeOnAuthFail', 'root.uos')
    .config(config);

  function config($urlRouterProvider, $stateProvider, $httpProvider, $locationProvider) {
    $urlRouterProvider.otherwise('/uos');

    $stateProvider.state('root', {
      url: '',
      abstract: true,
      views: {
        header: {
          template: '<v3g-header mostrar-menu-vfleets="true" gerenciar-permissoes="false" mostrar-filtro-uo="false"></v3g-header>',
          controller: 'HeaderCtrl',
          controllerAs: 'headerCtrl'
        }
      },
      resolve: {
        auth: (Authenticator, FeaturehubJsSdk) => Authenticator.init()
          .then(() => Authenticator.getUser())
          .then(usuario => addFeatureHubAttributes(FeaturehubJsSdk, usuario)
            .catch(() => undefined)
            .then(() => usuario)),
        translateReady: ['$translate', function ($translate) {
          return $translate.onReady();
        }]
      }
    })
    .state('unprotected', {
      abstract: true,
      views: {
        header: {
          template: '<div data-ui-view="guest@" class="view-content"></div>'
        }
      }
    });

    $locationProvider.html5Mode(true);

    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.defaults.headers.common.Accept = 'application/json';
    $httpProvider.interceptors.push(['$rootScope', '$q', 'Flash', '$window', '$injector', '$translate', function ($rootScope, $q, Flash, $window, $injector, $translate) {
      return {
        responseError: function (rejection) {
          let authenticator = $injector.get('Authenticator'),
              user = $rootScope.usuario;
          if (rejection.status === 401) {
            if (user) {
              const keysLocalStorage = Object.keys(angular.fromJson(angular.toJson(localStorage)));
              keysLocalStorage.forEach(key => {
                if (key.endsWith(`-${user.id}`)) {
                  localStorage.removeItem(key);
                }
              });
            }

            localStorage.removeItem('vfleets-oauth2-authorization');
            authenticator.init();
          } else if (rejection.status === 403) {
            Flash.create('danger', 'Erro! Usuário sem permissão para acessar este recurso.');
          } else if (rejection.status === 404) {
            Flash.create('danger', 'Erro! Serviço não encontrado.');
          } else if (rejection.data && rejection.data.message) {
            Flash.create('danger', rejection.data.message);
          } else {
            $translate('core-permissoes.organizacao.usuarios.popup.requestingTheServerMessageError').then(function (translatedMessage) {
              Flash.create('danger', translatedMessage);
            });
          }
          return $q.reject(rejection);
        }
      };
    }]);
  }

  function addFeatureHubAttributes(FeaturehubJsSdk, user) {
    if (!FeaturehubJsSdk || !user) {
      return Promise.resolve();
    }

    const uoId = user.uo && user.uo.id,
        role = user.perfil && user.perfil.nome;

    return FeaturehubJsSdk.setUserKey(user.id)
        .then(() => FeaturehubJsSdk.setAttributeValue('uo', uoId))
        .then(() => FeaturehubJsSdk.setAttributeValue('uoId', uoId))
        .then(() => FeaturehubJsSdk.setAttributeValue('email', user.email))
        .then(() => FeaturehubJsSdk.setAttributeValue('role', role));
  }
}());
